import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { USER_REGISTER_360, USER_REGISTER_360_SUCCESS, USER_REGISTER_360_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* userRegister360({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/create-manual-user-registration-draft`,
      method: 'POST',
      data: payload.data,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: USER_REGISTER_360_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: USER_REGISTER_360_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: USER_REGISTER_360_ERROR, payload: error });
  }
}

export function* watchUserRegister360() {
  yield takeEvery(USER_REGISTER_360, userRegister360);
}

function* userRegister360Saga() {
  yield all([fork(watchUserRegister360)]);
}

export default userRegister360Saga;
